import { Stack } from '@mui/material';
import { ReactNode } from 'react';

interface IBaseModule {
  children: ReactNode;
}

export const BaseModule = ({ children, ...props }: IBaseModule) => {
  return (
    <Stack spacing={3} sx={{ pb: 3 }} {...props}>
      {children}
    </Stack>
  );
};
